import React, { Component } from 'react'
import {
  // BrowserRouter as Router,
  // Switch,
  // Route,
  Link
} from "react-router-dom";
import logo from '../assets/img/brand/blue.png'
// import ImgProfile from '../assets/img/theme/team-1-800x800.jpg'
import ImgProfile from '../assets/img/theme/team-4-800x800.jpg'
import { Modal,ButtonToolbar,Button } from 'react-bootstrap';
import { TextArea } from 'semantic-ui-react';


class NavCollections extends React.Component{
  render(){
    return (
<ul className="navbar-nav">
            {/* Navigation */}
            <li className="nav-item">
              <Link className="nav-link" to="/"><i className="ni ni-tv-2 text-primary" /> Dashboard</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/quotation"><i className="ni ni-air-baloon text-blue"></i> Quotation</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/requotation"><i className="ni ni-bulb-61 text-red"></i> Reopen Quotation</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/orders"><i className="fa fa-cart-plus text-green" />Orders</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/notificaion"><i className="fa fa-bell text-yellow" />Notification</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/service"><i className="fa fa-cogs text-silver" aria-hidden="true" /> services</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/category"><i className="fa fa-sitemap text-warning" aria-hidden="true" /> category</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile"><i className="ni ni-single-02 text-green" /> My Profile</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/allusers"><i className="ni ni-single-02 text-grey" /> Users</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/exsoon"><i className="ni ni-single-02 text-red" /> Expiring Soon</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/tenant"><i className="ni ni-single-02 text-blue" /> Create Tenant</Link>
            </li>
            
            <li className="nav-item">
              <Link className="nav-link" to="/priority"><i className="fa fa-star text-yellow" />priority</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/promocode"><i className="fa fa-id-card text-red" /> Promocode</Link>
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/transaction"><i className="fa fa-id-card text-blue" />Transaction</Link>
            </li> */}
            <li className="nav-item">
              <Link className="nav-link" to="/header"><i className="fa fa-header text-blue" aria-hidden="true" /> Header</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/days"><i className="fa fa-calendar text-black" aria-hidden="true" /> Days</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/price"><i className="fa fa-list text-gold" aria-hidden="true" /> Price list</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/settings"><i className="fa fa-gear " aria-hidden="true" /> Settings</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/feedback">
              <i className="fa fa-comments text-purple" aria-hidden="true"></i>
                 Feedback</Link>
            </li>
          </ul>
    )
  }
}

class MyVerticallyCenteredModal extends React.Component {
  render() {
      return (
          <Modal
          {...this.props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
      >
          <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                  Navigate to :
          </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <NavCollections/>
          </Modal.Body>
      </Modal>
      )
  }
}

export default class NavigationItems extends Component {

  constructor(){
    super()
    this.state={
      modalShow:false
    }
  }
  handleShow=()=>{
    console.log('clicked menu ');
    this.setState({
      modalShow:!this.state.modalShow
    })
  }

  render() {

    return (
      <nav className="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
      <div className="container-fluid">
        {/* Toggler */}
        {/* <button className="navbar-toggler" type="button" onClick={handleShow}> */}
        <button className="navbar-toggler" type="button" onClick={this.handleShow}>
          <span className="navbar-toggler-icon" />
        </button>
        <MyVerticallyCenteredModal
          show={this.state.modalShow}
          onHide={() => this.setState({ modalShow: false })}
          />
        {/* Brand */}
        <Link className="navbar-brand pt-0" to="/">
          <div>
            <img src={logo} className="navbar-brand-img mt--2" alt="..." />
            <label className="ml-2 text-xl mt-50 ">Zukhrof</label>
          </div>
        </Link>
        {/* User */}
        <ul className="nav align-items-center d-md-none">
          <li className="nav-item dropdown">
            {/* <a className="nav-link"  role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> */}
              <div className="media align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <i className="fa fa-user" aria-hidden="true"></i>
                  {/* <img alt="Image" src={ImgProfile }/> */}
                </span>
              </div>
            {/* </a> */}
           
          </li>
        </ul>

        <div className="collapse navbar-collapse" id="sidenav-collapse-main">
        <NavCollections/>
      </div>
      </div>
    </nav>
    )
  }
}
